import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SocraPage from './pages/SocraPage';
import HuraPage from './pages/HuraPage';
import KAIStudyPage from './pages/KAIStudyPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import AristoPage from './pages/AristoPage';
import VTAPage from './pages/VTAPage';
import AchievementsPage from './pages/AchievementsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import StarryBackground from './components/StarryBackground';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <StarryBackground />
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/socra" element={<SocraPage />} />
          <Route path="/hura" element={<HuraPage />} />
          <Route path="/kaistudy" element={<KAIStudyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/aristo" element={<AristoPage />} />
          <Route path="/projects/kaistudy" element={<KAIStudyPage />} />
          <Route path="/projects/vta" element={<VTAPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
